import React, { useEffect, useState } from "react";
import Title from "../common/Title";
import { GiAlarmClock } from "react-icons/gi";
import Utils from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Button, Spinner, Alert } from "react-bootstrap";
import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";
import cronstrue from "cronstrue";
import { runbookSchedulerActions } from "../../actions/runbookScheduler.actions";
import { runbookActions } from "../../actions/runbook.actions";
import { useDispatch, useSelector } from "react-redux";
import SkeletonForm from "../common/SkeletonForm";
import { useToast } from "../../contexts/ToastContext";
import { usePermissions } from "../../hooks/usePermissions";

function SchedulerForm(props) {
  const { hideTitle, presetSchedulerId, onSaveSuccess, onCancel } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { hasPermission } = usePermissions(props.user);
  const [schedulerId, setSchedulerId] = useState("");
  const [runbookId, setRunbookId] = useState("");
  const [runbookGuid, setRunbookGuid] = useState("");
  const [cron, setCron] = useState("* * * * *");
  const [clientId, setClientId] = useState("");
  const [clientGuid, setClientGuid] = useState("");
  const schedulerReducer = useSelector((state) => state.scheduler);
  const runbookReducer = useSelector((state) => state.runbook);
  const [timezoneid, setTimezone] = useState("");
  const [active, setActive] = useState(true);

  useEffect(() => {
    let queryParams = Utils.getQueryStringParams(location);
    queryParams["clientId"] = props.user.clientId;
    queryParams["clientGuid"] = props.user.clientGuid;
    setCron("* * * * *");
    setClientId("");
    setClientGuid("");

    const schedulerIdToLoad = presetSchedulerId ?? queryParams["schedulerId"];
    if (schedulerIdToLoad) {
      queryParams["schedulerId"] = schedulerIdToLoad;
      setSchedulerId(schedulerIdToLoad);
      dispatch(runbookSchedulerActions.get(queryParams));
    } else if (queryParams["runbookId"]) {
      setSchedulerId("");
      setRunbookId(queryParams["runbookId"]);
        dispatch(runbookActions.get(queryParams));
    }
    // eslint-disable-next-line
  }, [location, presetSchedulerId]);

  useEffect(() => {
    if (
      schedulerId &&
      schedulerReducer.paginatedResult &&
      schedulerReducer.paginatedResult.data &&
      schedulerReducer.paginatedResult.data[0]?.runbookId
    ) {
      setRunbookId(schedulerReducer.paginatedResult.data[0].runbookId);
      setRunbookGuid(schedulerReducer.paginatedResult.data[0].runbookGuid);
      setCron(schedulerReducer.paginatedResult.data[0].cron);
      setClientId(schedulerReducer.paginatedResult.data[0].clientId);
      setClientGuid(schedulerReducer.paginatedResult.data[0].clientGuid);     
      if (schedulerReducer.paginatedResult.data[0].timeZoneId) {
          setTimezone(schedulerReducer.paginatedResult.data[0].timeZoneId);
      }
      setActive(schedulerReducer.paginatedResult.data[0].active ?? true);
    }
    // eslint-disable-next-line
  }, [schedulerReducer]);

  useEffect(() => {
    if (
      runbookId &&
      runbookReducer.paginatedResult &&
      runbookReducer.paginatedResult.data &&
      runbookReducer.paginatedResult.data[0]?.runbookId
    ) {
      setRunbookGuid(runbookReducer.paginatedResult.data[0].runbookGuid);
      setClientId(runbookReducer.paginatedResult.data[0].clientId);
      setClientGuid(runbookReducer.paginatedResult.data[0].clientGuid);
    }
    // eslint-disable-next-line
  }, [runbookReducer]);

  useEffect(() => {
    if (schedulerReducer.success) {
      showToast("Scheduler saved successfully", "success");
      if (onSaveSuccess) {
        onSaveSuccess();
      } else {
        navigate("/scheduler");
      }
    }
    // eslint-disable-next-line
  }, [schedulerReducer.success]); 




    useEffect(() => {
        let queryParams = Utils.getQueryStringParams(location);
        queryParams["clientId"] = props.user.clientId;
        queryParams["clientGuid"] = props.user.clientGuid;
        dispatch(runbookSchedulerActions.getTimeZone(queryParams));
    }, [dispatch, location, props.user.clientId, props.user.clientGuid]);


  const handleSaveScheduler = () => {
    if (schedulerId) {
      dispatch(
        runbookSchedulerActions.update({
          schedulerId,
          clientId,
          clientGuid,
          cron,
          timezoneid,
          active,
        })
      );
    } else {
      dispatch(
        runbookSchedulerActions.create({
          runbookId,
          runbookGuid,
          clientId,
          clientGuid,
          cron,
          timezoneid,
        })
      );
    }
  };

const operation = !schedulerId ? "Add" : "Update";
    
const timezoneOptions = (schedulerReducer.timezones || []).map((tz) => ({
    value: tz.timeZoneID,
    label: tz.timeZoneDisplayName,
}));


  return (
    <>
      {!hideTitle && (
        <Title
          text={`${operation} Scheduler`}
          icon={<GiAlarmClock className="mb-1" />}
        />
      )}

      {schedulerReducer.loading && <SkeletonForm fields={4} />}

      {!schedulerReducer.loading && (
        <>
          {!schedulerReducer.success && (
            <>
              {!schedulerReducer.loading && schedulerReducer.error && (
                <Alert variant={"danger"}>
                  An error has occurred. Please try again later.
                </Alert>
              )}

              <Form.Group controlId="formRunbookId" className="mb-3">
                <Form.Label>Runbook Id</Form.Label>
                <Form.Control
                  type="text"
                  value={runbookId}
                  onChange={(e) => setRunbookId(e.target.value)}
                  disabled
                />
              </Form.Group>

              <Form.Group controlId="formCron" className="mb-3">
                <Form.Label>Cron expression</Form.Label>
                <Cron value={cron} setValue={setCron} />
                <small>
                  {cron && (
                    <>
                      {cron} ({cronstrue.toString(cron)})
                    </>
                  )}
                </small>
              </Form.Group>


              <Form.Group controlId="formTimezone" className="mb-3">
                  <Form.Label>Time Zone</Form.Label>
                  <Form.Select value={timezoneid} onChange={(e) => setTimezone(e.target.value)}>
                      <option value="" disabled>Select an option</option>
                      {timezoneOptions.map((tz) => (
                          <option key={tz.value} value={tz.value}>
                              {tz.label}
                          </option>
                      ))}
                  </Form.Select>
              </Form.Group>

              {schedulerId && (
                <Form.Group controlId="formActive" className="mb-3">
                  <Form.Check
                    type="switch"
                    id="scheduler-active-switch"
                    label={active ? "Active" : "Inactive"}
                    checked={active}
                    onChange={(e) => setActive(e.target.checked)}
                    disabled={!hasPermission("schedules.edit")}
                  />
                  <small className="text-muted">
                    Disabled schedules won't execute on their cron schedule.
                  </small>
                </Form.Group>
              )}

              <Button
                variant="outline-secondary"
                type="submit"
                className="me-3 mt-3"
                onClick={() => (onCancel ? onCancel() : navigate(-1))}
              >
                Cancel
              </Button>

              <Button
                variant="primary"
                type="submit"
                className="mt-3"
                onClick={handleSaveScheduler}
                disabled={schedulerReducer.loading}
              >
                {!schedulerReducer.loading ? (
                  <>{operation} Scheduler</>
                ) : (
                  <Spinner size="sm" />
                )}
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
}

export default SchedulerForm;
